import { Ban, Eye } from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";

import { Action } from "../../../components/ui/Action";
import { CrmPetController } from "../../../services/controllers/crmPet";
import { useCrmPet } from "../../../store/crmPet/useCrmPet";

const actionButtonClass = "!h-8 !w-8 !min-w-8 !max-w-8 !p-0 !shadow-sm";
const actionButtonStyle = {
  width: 32,
  height: 32,
  minWidth: 32,
  maxWidth: 32,
  padding: 0,
};

export function PetRowActions({ customer }) {
  const CCrmPet = CrmPetController();
  const pet = customer.pet || customer.pets[0];
  const petBlocking = useCrmPet((state) => state.data.petBlocking);
  const blocked = pet?.blocked === true;

  return (
    <div className="flex items-center justify-end gap-2 w-full">
      <Action.Root
        status="success"
        type="button"
        title="Abrir WhatsApp"
        disabled={!customer.customerPhone || blocked || !customer.customerId || !customer.memberships.length}
        name={`open-whatsapp-${customer.customerKey}`}
        className={actionButtonClass}
        style={actionButtonStyle}
        onClick={() => CCrmPet.openWhatsApp(customer.customerKey)}
      >
        <Action.Icon icon={FaWhatsapp} size={16} />
      </Action.Root>
      <Action.Root
        outline
        status="danger"
        type="button"
        title={blocked ? `Desbloquear ${pet?.petName || "pet"}` : `Bloquear ${pet?.petName || "pet"}`}
        disabled={!pet?.petId || petBlocking[pet.petId]}
        name={`toggle-block-${customer.customerKey}`}
        className={actionButtonClass}
        style={actionButtonStyle}
        onClick={() => CCrmPet.toggleBlocked(pet)}
      >
        <Action.Icon icon={Ban} size={16} />
      </Action.Root>
      <Action.Root
        status="400"
        type="button"
        title="Ver histórico de contatos"
        name={`see-contact-history-${customer.customerKey}`}
        aria-label={`Ver histórico de contatos de ${customer.customerName}`}
        className={actionButtonClass}
        style={actionButtonStyle}
        onClick={() => CCrmPet.openContactHistory(customer)}
      >
        <Action.Icon icon={Eye} size={16} />
      </Action.Root>
    </div>
  );
}
